import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const sCQLotsControllerEndpoint = 'SubLotCreationCQL3';


export class UsedRentalsCQLotsAPI {

  getNegotiationCQLotByL2Id(ruL2Id) {
    return axios.get(getBackendURL() + sCQLotsControllerEndpoint + '/GetRUL3ListByL2Id?ruL2Id=' + ruL2Id);
  }

  saveNewNegotiationCQ(dto) {
    return axios.post(getBackendURL() + sCQLotsControllerEndpoint + '/CreateRUL3', dto);
  }

  saveEditNegotiationCQ(dto) {
    return axios.put(getBackendURL() + sCQLotsControllerEndpoint + '/UpdateRUL3', dto);
  }

  deleteNegotiationCQ(ruL3Id) {
    return axios.delete(getBackendURL() + sCQLotsControllerEndpoint + '/DeleteRUL3?ruL3Id=' + ruL3Id);
  }

}

export default UsedRentalsCQLotsAPI


// WEBPACK FOOTER //
// ./src/API/UsedRentalsCQLotsAPI.js